<template>
  <div
    class="markdown-content"
    v-html="renderedContent"
  ></div>
</template>

<script>
import MarkdownIt from 'markdown-it';

function productNamePlugin(md, options) {
  const defaultOptions = {
    products: {},
    wrapper: '%%',
  };

  options = Object.assign({}, defaultOptions, options);

  function escapeRegExp(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function replaceProductNames(text) {
    let newText = text;
    const wrapper = escapeRegExp(options.wrapper);
    Object.keys(options.products).forEach((key) => {
      const regexp = new RegExp(`${wrapper}${escapeRegExp(key)}${wrapper}`, 'g');
      newText = newText.replace(regexp, options.products[key]);
    });
    return newText;
  }

  function productNameRule(state) {
    for (let i = 0; i < state.tokens.length; i++) {
      const token = state.tokens[i];

      // 处理代码块
      if (token.type === 'fence' || token.type === 'code_block') {
        token.content = replaceProductNames(token.content);
        continue;
      }

      // 处理内联文本
      if (token.type === 'inline') {
        const tokens = token.children;

        for (let j = 0; j < tokens.length; j++) {
          if (tokens[j].type === 'text' || tokens[j].type === 'code_inline') {
            tokens[j].content = replaceProductNames(tokens[j].content);
          }

          if (tokens[j].type === 'link_open') {
            const attrs = tokens[j].attrs;
            console.log(attrs);
            const href = attrs.find((attr) => attr[0] === 'href');
            if (href) {
              href[1] = replaceProductNames(decodeURIComponent(href[1]));
              console.log(href[1]);
            }
          }
        }
      }
    }
  }

  md.core.ruler.after('inline', 'product_name', productNameRule);
}

export default {
  name: 'MarkDown',
  props: {
    content: {
      type: String,
      required: true,
    },
    products: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    const md = new MarkdownIt({
      html: true,
      typographer: true,
      breaks: true,
    });

    md.use(productNamePlugin, {
      products: this.products,
      wrapper: '%%',
    });

    return {
      md,
    };
  },
  computed: {
    renderedContent() {
      return this.md.render(this.content);
    },
  },
};
</script>

<style scoped>
</style>
